<script lang="ts">

	import type { Attribute } from "../groups/group";
	export let changeFn: () => void = () => {};
	export let attribute: Attribute;

	export let editEnabled: boolean
</script>

<td>{attribute.id}</td>
<td>{attribute.name}</td>


{#if editEnabled}
	<td>
		<input
			type="number"
			min="0"
			bind:value={attribute.level}
			on:change={changeFn}
		/>
	</td>
	<td>
		<input
			type="number"
			min="0"
			bind:value={attribute.object}
			on:change={changeFn}
		/>
	</td>
	<td>
		<input
			type="number"
			min="0"
			bind:value={attribute.special}
			on:change={changeFn}
		/>
	</td>
		
	<td>
		{attribute.total}
	</td>

{:else}
	<td/>
	<td/>
	<td/>
	<td/>
{/if}